<kendo-grid [kendoGridBinding]="gridView" [pageSize]="20" [filterable]="true" [pageable]="true" [sortable]="true"
    [groupable]="false" [reorderable]="true" [resizable]="true" [height]="height()"
    [selectable]="{enabled: true, checkboxOnly: true}" (sortChange)="sortChange($event)">
    <!--<ng-template kendoGridToolbarTemplate [hidden]="!isSubGrid">
        <button *ngIf="isSubGrid" kendoButton type="button" (click)="newItem()" [svgIcon]="newItemSVG">
            {{ 'toolbar.newItem' | transloco }}
        </button>
        <button kendoButton type="button" (click)="navigateToAdvancedSearch()" style="margin-right: auto;" [hidden]="false">
            {{ 'toolbar.advancedSearch' | transloco }}
        </button>
        <button *ngIf="canExport && isSubGrid" kendoButton type="button" (click)="exportToExcel()" [svgIcon]="excelSVG" [hidden]="true">
            {{ 'toolbar.exportToExcel' | transloco }}
        </button>
        
    </ng-template> -->


    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage" let-skip="skip"
        let-pageSize="pageSize" let-total="total">
        <div class="flex items-center w-full k-pager-numbers-wrap">
            <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
            <kendo-pager-numeric-buttons [buttonCount]="10"></kendo-pager-numeric-buttons>
            <kendo-pager-next-buttons></kendo-pager-next-buttons>
        </div>

        <div class="flex items-center mx-4">
            <div *ngIf="isDownloading" class="flex items-center text-sm italic opacity-80"
                style="color: var(--custom-color)">
                <div class="spin-animation mr-2">
                    <kendo-svg-icon [icon]="gearIcon"></kendo-svg-icon>
                </div>
                <span *ngIf="!total">Loading...</span>
            </div>

            <div class="text-sm font-medium" *ngIf="total > 0; else emptyPager">
                {{ skip + 1 }}-{{ (skip + pageSize > total) ? total : (skip + pageSize) }} / {{ total }}
            </div>

            <ng-template #emptyPager>
                <div class="text-sm font-medium" *ngIf="!isDownloading">0 / 0</div>
            </ng-template>
        </div>
    </ng-template>


    <kendo-grid-checkbox-column [width]="50" [headerClass]="{ 'text-center': true }" [class]="{ 'text-center': true }"
        [resizable]="false" [columnMenu]="false" [showSelectAll]="true"></kendo-grid-checkbox-column>

    <kendo-grid-command-column *ngIf="viewConfig.canEdit || viewConfig.canDelete || viewConfig.canView " title=" "
        [width]="getButtonColumnWidth()" [filterable]="false" [sortable]="false">
        <ng-template kendoGridCellTemplate let-dataItem>
            <div class="flex">
                <button *ngIf="isEditable(dataItem) " class="mx-2" (click)="editActivity(dataItem)"
                    [title]="'grid.button.editRecord' | transloco" kendoButton [svgIcon]="editSVG"
                    iconColor="var(--custom-color)">
                </button>
                <button *ngIf=" isEditable(dataItem) && viewConfig.canDelete" class="mx-2"
                    (click)="deleteActivity(dataItem)" [title]="'grid.button.deleteRecord' | transloco" kendoButton
                    [svgIcon]="deleteSVG" iconColor="var(--custom-color)">
                </button>
                <button *ngIf="!isEditable(dataItem)" class="mx-2" (click)="editActivity(dataItem)"
                    [title]="'grid.button.viewRecord' | transloco" kendoButton [svgIcon]="viewSVG"
                    iconColor="var(--custom-color)">
                </button>
                <button *ngIf="viewConfig.canAi" class="mx-2" (click)="aiAnalysis(dataItem)"
                    [title]="'grid.button.aiAnalysis' | transloco" kendoButton [svgIcon]="aiSVG"
                    iconColor="var(--custom-color)">
                </button>
                <ng-container *ngFor="let column of gridColumns">
                    <button *ngIf="column.fieldControlType === 'BUTTON'" class="mx-2"
                        (click)="buttonAction(dataItem, column)" [title]="column.title | transloco">
                        <div appHeroIcon [iconName]="column.fieldControlFormat" iconColor="var(--custom-color)"></div>
                    </button>
                </ng-container>
            </div>
        </ng-template>
    </kendo-grid-command-column>

    <kendo-grid-command-column *ngIf="!viewConfig.canEdit && !viewConfig.canDelete && !viewConfig.canView " title=" "
        [width]="getButtonColumnWidth()" [filterable]="false" [sortable]="false">
        <ng-template kendoGridCellTemplate let-dataItem>
            <div class="flex">
                <ng-container *ngFor="let column of gridColumns">
                    <button *ngIf="column.fieldControlType === 'BUTTON'" class="mx-2"
                        (click)="buttonAction(dataItem, column)" [title]="column.title | transloco">
                        <div appHeroIcon [iconName]="column.fieldControlFormat" iconColor="var(--custom-color)"></div>
                    </button>

                </ng-container>
            </div>
        </ng-template>
    </kendo-grid-command-column>

    <ng-container *ngFor="let column of gridColumns">
        <kendo-grid-column *ngIf="column.fieldControlType !== 'BUTTON'" [field]="column.field"
            [title]="column.title | transloco" [width]="column.width" [hidden]="column.hidden"
            [sortable]="column.sortable" [format]="column.format" [ngClass]="column.cssClass" [filter]="column.filter"
            [headerClass]="'wrap-header'">
            <ng-template kendoGridHeaderTemplate let-col="column">
                <span class="k-wrap-title" [title]="col.title | transloco">
                    {{ col.title | transloco }}
                </span>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>


                <ng-container *ngIf="column.template && column.template.trim() !== ''; else defaultTemplate">
                    <app-drake-grid-custom-template [templateStr]="column.template" [dataItem]="dataItem"
                        [column]="column"></app-drake-grid-custom-template>
                </ng-container>

                <ng-template #defaultTemplate>
                    <ng-container
                        *ngIf="column.fieldType === 'DROPDOWN' || column.fieldControlType === 'DROPDOWNLIST'; else fileTemplate">
                        {{dataItem[column.field]?.text}}

                        <button *ngIf="dataItem[column.field]?.url && canNavigate(column)" class="mx-2"
                            (click)="goTo(dataItem[column.field]?.url, column)" kendoButton [svgIcon]="linkSVG"
                            iconColor="var(--custom-color)">
                        </button>

                    </ng-container>
                </ng-template>

                <ng-template #fileTemplate>
                    <ng-container *ngIf="column.fieldType === 'FILE'; else checkboxtemplate">
                        <button kendoButton [svgIcon]="downloadSVG">
                            <a [href]="getFileUrl(dataItem, column.field)"
                                [attr.download]="getFileName(dataItem, column.field)">
                                {{getFileName(dataItem, column.field)}}
                            </a>

                        </button>
                    </ng-container>
                </ng-template>

                <ng-template #checkboxtemplate>
                    <ng-container *ngIf="column.fieldControlType === 'CHECKBOX'; else dateTemplate">
                        <div class="text-center">
                            <input type="checkbox" class="k-checkbox k-checkbox-md k-rounded-md" disabled
                                [checked]="dataItem[column.field]">
                        </div>

                    </ng-container>
                </ng-template>

                <ng-template #dateTemplate>
                    <ng-container *ngIf="column.fieldType === 'DATETIME'; else htmltemplate">
                        {{getFormattedDate(dataItem[column.field])}}
                    </ng-container>
                </ng-template>
                <ng-template #htmltemplate>
                    <ng-container *ngIf="column.fieldControlType === 'HTML'; else colortemplate">
                        <div [innerHTML]="sanitizeHtml(dataItem[column.field])"></div>
                    </ng-container>
                </ng-template>
                <ng-template #colortemplate>
                    <ng-container *ngIf="column.fieldControlType === 'COLORPICKER'; else locationtemplate">
                        <span [innerHTML]="getColorSquare(dataItem[column.field]?.value)"></span>
                        {{dataItem[column.field]?.value}}
                    </ng-container>
                </ng-template>


                <ng-template #locationtemplate>
                    <ng-container *ngIf="column.fieldControlType === 'FULL'; else objectTemplate">
                        <div style="display: flex; align-items: center;">
                            <span *ngIf="dataItem[column.field]?.description"
                                title="Lat: {{dataItem[column.field]?.lat}}, Lon: {{dataItem[column.field]?.lon}}">
                                <button kendoButton [svgIcon]="markerSVG" style="
                            background: none;
                            border: none;
                            padding: 0;
                            margin: 0;
                            cursor: default;
                            line-height: 0;
                            box-shadow: none;
                            ">
                                </button>
                            </span>
                            <span style="margin-left: 8px;">
                                {{ dataItem[column.field]?.lat }}, {{ dataItem[column.field]?.lon }}
                            </span>
                        </div>
                    </ng-container>
                </ng-template>


                <ng-template #objectTemplate>
                    <ng-container *ngIf="column.fieldControlType === 'CODEEDITOR'; else ratingTemplate">
                        {{ dataItem[column.field] }}
                    </ng-container>
                </ng-template>

                <ng-template #ratingTemplate>
                    <ng-container *ngIf="column.fieldControlType === 'RATING'; else sliderTemplate">
                        <div class="m-5">
                            <kendo-rating precision="half" [value]="dataItem[column.field]" [readonly]="true">
                            </kendo-rating>
                        </div>
                    </ng-container>
                </ng-template>

                <ng-template #sliderTemplate>
                    <ng-container *ngIf="column.fieldControlType === 'SLIDER'; else maskedTemplate">
                        <kendo-slider [value]="dataItem[column.field]" [readonly]="true">
                        </kendo-slider>
                    </ng-container>
                </ng-template>

                <ng-template #maskedTemplate>
                    <ng-container
                        *ngIf="column.fieldControlType === 'MASKED' && dataItem[column.field]; else matrixTemplate">
                        {{ formatMasked(dataItem[column.field]) }}
                    </ng-container>
                </ng-template>

                <ng-template #matrixTemplate>
                    <ng-container *ngIf="column.fieldControlType === 'MATRIX'; else privateFileTemplate">
                        {{ dataItem[column.field]}}
                    </ng-container>
                </ng-template>


                <ng-template #privateFileTemplate>
                    <ng-container *ngIf="column.fieldControlType === 'PRIVATEFILE'; else decimalTemplate">
                        <button kendoButton [svgIcon]="downloadSVG">
                            <a [href]="getPrivateFileUrl(dataItem, column.field)">{{'grid.privateFile.download' |
                                transloco }}</a>

                        </button>
                    </ng-container>
                </ng-template>

                <ng-template #decimalTemplate>
                    <ng-container *ngIf="column.fieldType === 'DECIMAL'; else normalTemplate">
                        {{getFormattedValue(dataItem[column.field])}}
                    </ng-container>
                </ng-template>





                <ng-template #normalTemplate>
                    {{ dataItem[column.field] }}

                    <button *ngIf="dataItem[column.field] && column.fieldControlFormat== 'LNK'" class="mx-2"
                        (click)="goToUrl(dataItem[column.field])" target="_blank" kendoButton [svgIcon]="linkSVG"
                        iconColor="var(--custom-color)">
                    </button>
                    <button *ngIf="dataItem[column.field] && column.fieldControlFormat === 'EML'" class="mx-2"
                        (click)="goToUrl('mailto:' + dataItem[column.field])" target="_blank" kendoButton
                        [svgIcon]="emailSVG" iconColor="var(--custom-color)">
                    </button>

                </ng-template>
            </ng-template>

            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                <div class="flex w-full">

                    <div class="flex-grow overflow-hidden">
                        <ng-container [ngSwitch]="column.filter">

                            <ng-container *ngSwitchCase="'dropdownlist'">
                                <kendo-dropdownlist [data]="filteredDropdownOptions[column.field]" [filterable]="true"
                                    textField="text" valueField="value" (valueChange)="onFilterChange($event, column)"
                                    [valuePrimitive]="true" (filterChange)="handleFilterDrp($event, column.field)"
                                    [(ngModel)]="column.filterValue">
                                </kendo-dropdownlist>
                            </ng-container>

                            <ng-container *ngSwitchCase="'html'">
                                <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                                </kendo-grid-string-filter-cell>
                            </ng-container>

                            <ng-container *ngSwitchCase="'colorPicker'">
                                <kendo-dropdownlist [data]="dropdownOptions[column.field]" [filterable]="true"
                                    textField="text" valueField="value" (valueChange)="onFilterChange($event, column)"
                                    [valuePrimitive]="true" [(ngModel)]="column.filterValue">

                                    <ng-template kendoDropDownListItemTemplate let-dataItem>
                                        <span [innerHTML]="getColorSquare(dataItem.value)"></span>
                                        {{dataItem.text}}
                                    </ng-template>

                                    <ng-template kendoDropDownListValueTemplate let-dataItem>
                                        <ng-container *ngIf="dataItem && dataItem.value">
                                            <span [innerHTML]="getColorSquare(dataItem.value)"></span>
                                            {{dataItem.text}}
                                        </ng-container>
                                    </ng-template>

                                </kendo-dropdownlist>
                            </ng-container>

                            <ng-container *ngSwitchCase="'boolean'">

                                <kendo-grid-boolean-filter-cell [column]="column" [filter]="filter">

                                </kendo-grid-boolean-filter-cell>

                            </ng-container>



                            <ng-container *ngSwitchCase="'numeric'">
                                <kendo-grid-numeric-filter-cell kendoGridFilterInput [column]="column"
                                    [filter]="filter">
                                </kendo-grid-numeric-filter-cell>
                            </ng-container>


                            <ng-container *ngSwitchCase="'decimal'">
                                <kendo-grid-numeric-filter-cell kendoGridFilterInput [column]="column" [filter]="filter"
                                    [format]="column.format">
                                </kendo-grid-numeric-filter-cell>
                            </ng-container>

                            <ng-container *ngSwitchCase="'date'">
                                <!-- 
                                <kendo-grid-date-filter-cell [value]="value" [column]="column" [filter]="filter"
                                    (filterChange)="onDateFilterChange($event, column)" [format]="format"
                                    [placeholder]="format">

                                </kendo-grid-date-filter-cell> 
                                -->
                                <div style="display: flex; align-items: center; gap: 4px;">
                                    <kendo-datepicker (valueChange)="onDateFilterChange($event, column)"
                                        [value]="column.filterValue" [placeholder]="column.format"
                                        [format]="column.format ?? 'dd/MM/yyyy'">
                                    </kendo-datepicker>
                                    <kendo-grid-filter-cell-operators [filter]="filter" [column]="column"
                                        (filterChange)="onFilterChange($event)" [showOperators]="true">
                                    </kendo-grid-filter-cell-operators>
                                </div>
                            </ng-container>

                            <ng-container *ngSwitchCase="'text'">
                                <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                                </kendo-grid-string-filter-cell>
                            </ng-container>

                            <ng-container *ngSwitchCase="'location'">
                                <kendo-textbox [(ngModel)]="searchQuery" (input)="onSearch($event.target.value)">
                                </kendo-textbox>
                            </ng-container>

                            <ng-container *ngSwitchCase="'array'">
                                <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                                </kendo-grid-string-filter-cell>
                            </ng-container>


                            <ng-container *ngSwitchCase="'codeEditor'">
                                <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                                </kendo-grid-string-filter-cell>
                            </ng-container>

                            <ng-container *ngSwitchDefault>
                                <input kendoGridFilterInput [column]="column" [filter]="filter" />
                            </ng-container>
                        </ng-container>
                    </div>

                    <div class="w-[20px] flex-none flex items-center justify-center"
                        [class.hidden]="!hasFilterValue(column)">
                        <button kendoButton fillMode="clear" [svgIcon]="filterClearIcon"
                            [hidden]="!hasFilterValue(column)" (click)="resetColumnFilter(column, filter)">
                        </button>
                    </div>

                </div>


            </ng-template>
        </kendo-grid-column>
    </ng-container>

    <kendo-excelexport #excelexport [data]="exportGridData" [fileName]="getExportFileName()">
        <kendo-excelexport-column *ngFor="let column of gridColumns" [field]="column.field"
            [title]="column.title | transloco" [width]="column.width" [hidden]="column.hidden"
            [cellOptions]="{ format: column.format }">
        </kendo-excelexport-column>
    </kendo-excelexport>


</kendo-grid>